import { render, staticRenderFns } from "./Cams.vue?vue&type=template&id=be4a5ef4&"
import script from "./Cams.vue?vue&type=script&lang=js&"
export * from "./Cams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports